import React, {Suspense, useEffect} from 'react';
import { ElfsightWidget } from 'react-elfsight-widget';
import dynamic from 'next/dynamic';
import ArticleTypes from "../../articles/ArticleTypes";
import Checkers from "../../../../helpers/class/Checkers";
import Consts from "../../../../helpers/class/Consts";
import ArticleCategoriesContainer from "../../articles/ArticleCategoriesContainer";
import {useDispatch, useSelector} from "react-redux";
import {fetchBuilderSettingByKey} from "../../../../helpers/MethodHelper";
import SwipeableDrawerFilters from "../../property/content/columned/right/SwipeableDrawerFilters";
import Calendar from "../../../../helpers/class/Calendar";
import FlexibleSearchBar from '../bookingSearchBar/FlexibleSearchBar';
import PropertiesSection from "./PropertiesSection";
import BlogSection from "./BlogSection";
import ServicesSection from "./ServicesSection";
import {HomepageSections} from "./HomepageSections";
import PropertyContent from "../../property/Content";
import OverviewSection from "./OverviewSection";
import GoogleMapSection from "../../../GoogleMapSection";
import {GridImagesDesktop} from "../../../jumbotron/GridImagesDesktop";

const Header = dynamic( () => import( '../../../Header' ) );
const Jumbotron = dynamic( () => import( '../../../Jumbotron' ), { suspense: true });
const BookingSearchBar = dynamic( () => import( '../BookingSearchBar' ), { suspense: true });
const BottomSections = dynamic( () => import( '../../../BottomSections' ), { suspense: true });
const DistinctSection = dynamic( () => import( './DistinctSection' ), { suspense: true });
const ProfileSection = dynamic( () => import( './ProfileSection' ), { suspense: true });
const DestinationsSection = dynamic( () => import( './DestinationsSection' ), { suspense: true });
const CollectionsSection = dynamic( () => import( './CollectionsSection' ), { suspense: true });


interface IndexSectionsProps {
    isDesktop : any
    html_sections : any
    app_data : any
    head : any
    app : any
    builder : any
    navigation : any
    content : any
    propertyContent ?: any
    propertyAllImages ?: any
    propertyFeatures ?: any
    locations : any
    footer : any
    distincts : any
    profile : any
    destinations : any
    collections : any
    isHomepage : any
    isExperiencesPage ?: boolean
    categoriesContentDefault ?: any
    categoriesContentPromoted ?: any
    categoriesContentPromoted2 ?: any
    experienceCategoriesContentDefault ?: any
    experienceCategoriesContentPromoted ?: any
    experienceCategoriesContentPromoted2 ?: any
    htmlSections?: any
}

export default function IndexSections
(
    {
        isDesktop,
        html_sections,
        app_data,
        head,
        app,
        builder,
        navigation,
        content,
        propertyContent,
        propertyAllImages,
        propertyFeatures,
        locations,
        footer,
        distincts,
        profile,
        destinations,
        collections,
        isHomepage,
        isExperiencesPage = false,
        categoriesContentDefault,
        categoriesContentPromoted,
        categoriesContentPromoted2,
        experienceCategoriesContentDefault,
        experienceCategoriesContentPromoted,
        experienceCategoriesContentPromoted2,
        htmlSections
    } : IndexSectionsProps
) {

    let header_section = true;
    let jumbotron_section = true;
    let contact_section = true;
    let footer_section = true;

    // if ( html_sections != null ) {
    //   // header_section = false;
    //   // jumbotron_section = false;
    //   // contact_section = false;
    //   // footer_section = false;
    //   // html_sections.forEach( ( obj ) => {
    //   //
    //   //   if ( obj.app_section_type == 'SYSTEM_HEADER' ) {
    //   //     header_section = true;
    //   //   }
    //   //   if ( obj.app_section_type == 'SYSTEM_JUMBOTRON' ) {
    //   //     jumbotron_section = true;
    //   //   }
    //   //   if ( obj.app_section_type == 'SYSTEM_CONTACT' ) {
    //   //     contact_section = true;
    //   //   }
    //   //   if ( obj.app_section_type == 'SYSTEM_FOOTER' ) {
    //   //     footer_section = true;
    //   //   }
    //   // });
    // }

    // No explicit searchbar mode: follow the same Dark/Light mode as the header (designMode).
    const isSearchbarThemeLight = app.searchbarThemeColor != null
        ? !app.searchbarThemeColor
        : Checkers.valueToBoolean(app.designMode);

    let textColor = 'text-black';
    let borderColor = 'b-transparent-black';
    let buttonColor = 'b-transparent-black';
    if (isSearchbarThemeLight) {
        textColor = 'text-white';
        borderColor = 'b-transparent-white';
        buttonColor = 'b-transparent-white';
    }

    const contactIcons = {
        phoneIcon: app.showPhoneIconOnMenu,
        chatIcon: app.showChatIconOnMenu,
        mailIcon: app.showMailIconOnMenu,
        phoneIconData: app.menuPhoneIconData,
        chatIconData: app.menuChatIconData,
        mailIconData: app.menuMailIconData
    }

    const isHomePageRedux = useSelector(state => state['appSettings']['isHomepage'])

    // const textColor = (dark_text) => {
    //     if (dark_text != undefined && dark_text != false) {
    //         return ""
    //     }

    //     return "text-light-color"
    // }

    const contentTypeHandler = (type) => {
        return Checkers.isValidString(type) && type;
    }


    Calendar.setProps({
        isDesktop,
        html_sections,
        app_data,
        head,
        app,
        builder,
        navigation,
        content,
        locations,
        footer,
        distincts,
        profile,
        destinations,
        collections,
        isHomepage,
        categoriesContentDefault,
        categoriesContentPromoted,
        categoriesContentPromoted2
    });

    const calendarMaterialTheme = Calendar.getCalendarMaterialTheme;

    const calendar = {
        customTheme: calendarMaterialTheme,
    };

    const homepageSections = app.homepageSections

    const showProfileSection = useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_homepage_profile_show_in_homepage')
    );

    const showDistincsSection = useSelector(
        state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_homepage_distincts_show_in_homepage')
    );

    const distinctsBackgroundColor = app.builder.builder_homepage_distincts_background_color

    const distinctsDarkMode = app.builder.builder_homepage_distincts_dark_mode

    const isVillaContentActive = isHomepage && content.property_id && !content.is_chain && !app_data.is_manager && propertyContent != null;

    const usingJumbotronBaseImage = !content.is_chain && Checkers.isValidString(app.designMainCarouselImage);

    const jumbotronAlbum = usingJumbotronBaseImage
        ? [ { image: app.designMainCarouselImage, image_webp: app.designMainCarouselImage, caption: null } ]
        : content.album;

    const searchBarInDrawer = useSelector(
        state => Checkers.valueToBoolean(fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_general_search_in_drawer'))
    );

    const jumbotronIsPropertyGrid = (app.bookingSearchbarWidth === true && content.albumIsPageAlbum === false && !content.is_chain);
    const villaGridPhotos = Checkers.isValidArray(propertyAllImages)
        ? propertyAllImages
        : (propertyContent?.album || []);

    const jumbotronVideo = content.details.hasOwnProperty('video') && content.details.video != null ? content.details.video.length > 0 ? content.details.video : null : null;

    const isSingleVillaFlexible =
        jumbotronVideo == null &&
        app.enableBooking &&
        app.bookingSearchbarWidth == null &&
        content.albumIsPageAlbum === false &&
        !content.is_chain &&
        !app_data.is_manager &&
        !usingJumbotronBaseImage;

    const singleVillaFlexPos =
        app.bookingSearchbarPosition == null ? 'top'
            : app.bookingSearchbarPosition ? 'bottom'
                : null;

    const singleVillaFlexActive = isSingleVillaFlexible && singleVillaFlexPos != null;

    const jumbotronShowsPropertyPhotos = jumbotronVideo == null && !usingJumbotronBaseImage && content.albumIsPageAlbum === false;

    const showVillaGalleryGrid = isVillaContentActive && !jumbotronIsPropertyGrid && !singleVillaFlexActive && !jumbotronShowsPropertyPhotos && Checkers.isValidArray(villaGridPhotos);

    const singleVillaFlexBar = isDesktop ? (
        <Suspense>
            <BookingSearchBar
                key={'SingleVillaFlexibleBar'}
                sliderSearchBar={true}
                isFlexible={true}
                inSingleVilla={singleVillaFlexPos}
                isDesktop={isDesktop}
                isManager={app_data.is_manager}
                managerInfo={content.managerContact}
                designMode={app.designMode}
                calendar={calendar}
                searchbarRadius={app.searchbarRadius != null ? app.searchbarRadius.length > 0 ? app.searchbarRadius : null : null}
                searchbarShadow={app.searchbarShadow != null ? app.searchbarShadow.length > 0 ? app.searchbarShadow : null : null}
                searchbarThemeColor={app.searchbarThemeColor != null ? app.searchbarThemeColor : null}
                searchbarBgColor={app.searchbarBgColor != null && app.searchbarBgColor != '' ? app.searchbarBgColor : null}
                bookingSearchbarWithBedrooms={app.hasOwnProperty('bookingSearchbarWithBedrooms') ? !!app.bookingSearchbarWithBedrooms : false}
                isHomePage={true}
                updateUri={true}
                bookingTypeValue={app.bookingTypeValue}
                webHotelierRoomCodes={content.webHotelierRoomCodes}
                webHotelierBookUrl={content.webHotelierBookUrl}
                propertyBookingTypeValue={content.propertyBookingTypeValue}
            />
        </Suspense>
    ) : (
        <Suspense>
            <FlexibleSearchBar
                key={'SingleVillaFlexibleBarMobile'}
                isManager={app_data.is_manager}
                managerInfo={content.managerContact}
                textColor={textColor}
                borderColor={borderColor}
                calendar={calendar}
                designMode={app.designMode}
                updateUri={true}
                showOnMobile={true}
                inSingleVilla={singleVillaFlexPos}
                searchbarBgColor={app.searchbarBgColor != null && app.searchbarBgColor != '' ? app.searchbarBgColor : null}
                searchbarThemeColor={app.searchbarThemeColor != null ? app.searchbarThemeColor : null}
                bookingTypeValue={app.bookingTypeValue}
                webHotelierRoomCodes={content.webHotelierRoomCodes}
                webHotelierBookUrl={content.webHotelierBookUrl}
                propertyBookingTypeValue={content.propertyBookingTypeValue}
            />
        </Suspense>
    );

    return (
        <React.Fragment key={'page'}>
            {/*{*/}
            {/*    header_section ?*/}
            {/*        <Suspense>*/}
            {/*            <Header*/}
            {/*                key={'header'}*/}
            {/*                app={app}*/}
            {/*                builder={builder}*/}
            {/*                phone={head.location[0].phone}*/}
            {/*                menu={navigation.menu}*/}
            {/*                partials={navigation.partials}*/}
            {/*                showBookButtonMenu={app.showBookButtonMenu}*/}
            {/*                contactIcons={app.showContactIconsOnMenu ? contactIcons : null}*/}
            {/*                pageTitle={head.data.title}*/}
            {/*                property={isExperiencesPage ? true : false}*/}
            {/*                zIndex={1027}*/}
            {/*            />*/}
            {/*        </Suspense>*/}
            {/*        :*/}
            {/*        <></>*/}
            {/*}*/}
            {
                isHomepage && jumbotron_section ?
                    <>
                        <div className={singleVillaFlexActive ? 'single-villa-jumbo' : undefined} style={{ position: 'relative' }}>
                        {singleVillaFlexActive && (
                            <style dangerouslySetInnerHTML={{ __html:
                                '.single-villa-jumbo .jumbotron{background-color:transparent!important;}' }}
                            />
                        )}
                        {singleVillaFlexActive && singleVillaFlexPos === 'top' ? singleVillaFlexBar : <></>}
                        <Suspense>
                            <Jumbotron
                                key={'jubmotron'}
                                withMotto={true}
                                isDesktop={isDesktop}
                                isManager={app_data.is_manager}
                                content={content.details}
                                pageTitle={head.data.title}
                                motto={content.details.motto}
                                album={jumbotronAlbum}
                                forceSwiperSingleImage={usingJumbotronBaseImage}
                                property={(app.bookingSearchbarWidth === true && content.albumIsPageAlbum === false && !content.is_chain) || singleVillaFlexActive}
                                propertyJumbotronType={((app.bookingSearchbarWidth === true && content.albumIsPageAlbum === false && !content.is_chain) || singleVillaFlexActive) ? Consts.JumbotronGridImage : undefined}
                                designMode={app.designMode}
                                logoDecoration={app.logoDecoration}
                                logoDecorationOriginWidth={app.logoDecorationOriginWidth}
                                logoDecorationOriginHeight={app.logoDecorationOriginHeight}
                                jumbotronHeight={app.jumbotronHeight}
                                jumbotronAutoplay={app.jumbotronAutoplay}
                                jumbotronOverlayOpacity={app.jumbotronOverlayOpacity}
                                jumbotronTextAlign={app.jumbotronTextAlign}
                                jumbotronTextColor={app.jumbotronTextColor}
                                sliderTitleShadow={app.sliderTitleShadow}
                                sliderTitleBold={app.sliderTitleBold}
                                sliderThumbnails={app.sliderThumbnails}
                                video={jumbotronVideo}
                                homeTitle={app.hasOwnProperty('homeTitle') && app.homeTitle != null ? app.homeTitle.length > 0 ? app.homeTitle : null : null}
                                homeSubtitle={app.hasOwnProperty('homeSubtitle') && app.homeSubtitle != null ? app.homeSubtitle.length > 0 ? app.homeSubtitle : null : null}
                                sliderSearchBar={!singleVillaFlexActive && (app.enableBooking && !(app.bookingSearchbarWidth) && !(app.bookingSearchbarPosition))}
                                sliderSearchBarTop={!singleVillaFlexActive && (app.enableBooking && (app.bookingSearchbarWidth == null) && app.bookingSearchbarPosition)}
                                sliderSearchBarBelowHeader={!singleVillaFlexActive && (app.enableBooking && (app.bookingSearchbarWidth == null) && app.bookingSearchbarPosition == null)}
                                isFlexible={app.bookingSearchbarWidth == null}
                                searchbarRadius={app.searchbarRadius != null ? app.searchbarRadius.length > 0 ? app.searchbarRadius : null : null}
                                searchbarShadow={app.searchbarShadow != null ? app.searchbarShadow.length > 0 ? app.searchbarShadow : null : null}
                                bookingSearchbarWithBedrooms={app.hasOwnProperty('bookingSearchbarWithBedrooms') ? !!app.bookingSearchbarWithBedrooms : false}
                                searchbarThemeColor={app.searchbarThemeColor}
                                bookingTypeValue={app.bookingTypeValue}
                                webHotelierRoomCodes={content.webHotelierRoomCodes}
                                webHotelierBookUrl={content.webHotelierBookUrl}
                                propertyBookingTypeValue={content.propertyBookingTypeValue}
                                managerInfo={content.managerContact}
                            />
                        </Suspense>
                        {singleVillaFlexActive && singleVillaFlexPos === 'bottom' ? singleVillaFlexBar : <></>}
                        {
                            (isDesktop || !searchBarInDrawer) && app.enableBooking ?
                                !(app.bookingSearchbarWidth) && app.bookingSearchbarPosition && app.bookingSearchbarWidth != null?
                                    <section className="booking-bar position-relative z-index-2">
                                        <div className="container position-absolute start-50 translate-middle">
                                            <h2 className="hidden">Booking Bar</h2>
                                            <Suspense>
                                                <BookingSearchBar
                                                    key={'BookingSearchBar'}
                                                    isDesktop={isDesktop}
                                                    isManager={app_data.is_manager}
                                                    designMode={app.designMode}
                                                    searchbarThemeColor={app.searchbarThemeColor}
                                                    underSliderContained={true}
                                                    searchbarRadius={app.searchbarRadius != null ? app.searchbarRadius.length > 0 ? app.searchbarRadius : null : null}
                                                    searchbarShadow={app.searchbarShadow != null ? app.searchbarShadow.length > 0 ? app.searchbarShadow : null : null}
                                                    bookingSearchbarWithBedrooms={app.hasOwnProperty('bookingSearchbarWithBedrooms') ? !!app.bookingSearchbarWithBedrooms : false}
                                                    isHomePage={true}
                                                    bookingTypeValue={app.bookingTypeValue}
                                                    webHotelierRoomCodes={content.webHotelierRoomCodes}
                                                    webHotelierBookUrl={content.webHotelierBookUrl}
                                                    propertyBookingTypeValue={content.propertyBookingTypeValue}
                                                    managerInfo={content.managerContact}
                                                />
                                            </Suspense>
                                        </div>
                                    </section>
                                    : app.bookingSearchbarWidth ?
                                        <Suspense>
                                            <BookingSearchBar
                                                isDesktop={isDesktop}
                                                key={'BookingSearchBar'}
                                                isManager={app_data.is_manager}
                                                fullWidthBar={true}
                                                designMode={app.designMode}
                                                bookingSearchbarWithBedrooms={app.hasOwnProperty('bookingSearchbarWithBedrooms') ? !!app.bookingSearchbarWithBedrooms : false}
                                                searchbarThemeColor={app.searchbarThemeColor != null ? app.searchbarThemeColor : null}
                                                searchbarBgColor={app.searchbarBgColor != null && app.searchbarBgColor != '' ? app.searchbarBgColor : null}
                                                position={app.bookingSearchbarPosition}
                                                isHomePage={true}
                                                bookingTypeValue={app.bookingTypeValue}
                                                webHotelierRoomCodes={content.webHotelierRoomCodes}
                                                webHotelierBookUrl={content.webHotelierBookUrl}
                                                propertyBookingTypeValue={content.propertyBookingTypeValue}
                                                managerInfo={content.managerContact}
                                            />
                                        </Suspense>
                                        :
                                        <></>
                                :
                                <></>
                        }
                            {(!isDesktop && searchBarInDrawer && app.enableBooking && app.bookingSearchbarWidth == null && !singleVillaFlexActive) ? (() => {
                                const isBelowHeader = app.bookingSearchbarPosition == null;
                                const isBottom = !!app.bookingSearchbarPosition;
                                const posStyle = isBelowHeader
                                    ? { position: 'absolute' as const, top: '25%', left: 0, right: 0, zIndex: 10 }
                                    : isBottom
                                        ? { position: 'absolute' as const, bottom: 0, left: 0, right: 0, zIndex: 10 }
                                        : { position: 'absolute' as const, top: '65%', left: 0, right: 0, zIndex: 10, transform: 'translateY(-50%)' };
                                return (
                                    <div style={posStyle}>
                                        <FlexibleSearchBar
                                            isManager={app_data.is_manager}
                                            textColor={textColor}
                                            borderColor={borderColor}
                                            calendar={calendar}
                                            designMode={app.designMode}
                                            updateUri={true}
                                            showOnMobile={true}
                                            searchbarBgColor={app.searchbarBgColor != null && app.searchbarBgColor != '' ? app.searchbarBgColor : null}
                                            searchbarThemeColor={app.searchbarThemeColor != null ? app.searchbarThemeColor : null}
                                            bookingTypeValue={app.bookingTypeValue}
                                            webHotelierRoomCodes={content.webHotelierRoomCodes}
                                            webHotelierBookUrl={content.webHotelierBookUrl}
                                            propertyBookingTypeValue={content.propertyBookingTypeValue}
                                            managerInfo={content.managerContact}
                                        />
                                    </div>
                                );
                            }
                            )() :
                                <></>
                            }
                        </div>
                        {(!isDesktop && searchBarInDrawer && app.enableBooking && app.bookingSearchbarWidth != null) ? (
                            <SwipeableDrawerFilters key={'SwipeableDrawerFilters'} forHomepage={isHomepage} calendar={calendar}/>
                        ): <></>}
                    </>
                    :
                    <></>
            }

            {
                isVillaContentActive ?
                    <Suspense>
                        <PropertyContent
                            overviewBeforeSpaces={<OverviewSection details={propertyContent.details} themes={propertyContent.themes}/>}
                            distinctsBeforeAttributes={showDistincsSection && distincts && distincts.distincts.length > 0 ? <DistinctSection distincts={distincts} backgroundColor={distinctsBackgroundColor} darkMode={distinctsDarkMode}/> : null}
                            app={app}
                            app_data={app_data}
                            builder={builder}
                            hideSidebar={true}
                            hideDescription={true}
                            hideThemes={true}
                            hideFeaturedImages={true}
                            hideExperiences={true}
                            hideTerms={true}
                            fourColumnsFeatures={true}
                            mediaAfterPolicies={true}
                            hideMedia={true}
                            hideMap={true}
                            galleryAfterProfile={showVillaGalleryGrid ? <div className={'py-4'}><GridImagesDesktop album={villaGridPhotos} isProperty={true} isManager={false} modalState={null} videoUrl={null}/></div> : null}
                            profileBeforeSpaces={showProfileSection == 1 && profile ? <Suspense><ProfileSection profile={profile} readMoreBrief={content.propertyDescBrief} readMoreDetails={content.propertyDescDetails} /></Suspense> : null}
                            details={propertyContent.details}
                            terms={propertyContent['terms']}
                            location={propertyContent.location}
                            images={propertyContent.album}
                            images_count={propertyContent.images_count}
                            all_images={propertyAllImages}
                            spaces={propertyContent.spaces}
                            features={propertyFeatures}
                            services={propertyContent.services}
                            highlights={propertyContent.highlights}
                            themes={propertyContent.themes}
                            googleMapShow={app.viewMap}
                            googleMapApiKey={app.googleMapsApiKey}
                            page_title={propertyContent.page_title}
                            map_pois={propertyContent.map_pois}
                            phone={head.location?.phone}
                            hasOpenCalendar={propertyContent.hasOpenCalendar}
                        />
                    </Suspense>
                    :
                    <></>
            }

            {
                isHomepage ?
                    <HomepageSections
                        app={app}
                        app_data={app_data}
                        builder={builder}
                        isDesktop={isDesktop}
                        isHomepage={isHomepage}
                        categoriesContentPromoted={categoriesContentPromoted}
                        experienceCategoriesContentPromoted={experienceCategoriesContentPromoted}
                        profile={profile}
                        destinations={destinations}
                        categoriesContentPromoted2={categoriesContentPromoted2}
                        experienceCategoriesContentPromoted2={experienceCategoriesContentPromoted2}
                        distincts={distincts}
                        collections={collections}
                        experienceCategoriesContentDefault={experienceCategoriesContentDefault}
                        categoriesContentDefault={categoriesContentDefault}
                        hideProfileSection={isVillaContentActive}
                        hideDistinctsSection={isVillaContentActive}
                        propertiesTexts={content?.details}
                        />
                    :
                    <></>
            }

            {
                isHomepage && html_sections != null && html_sections != undefined ?
                    html_sections.map((section, index) => {
                        if (section.app_section_position == 'after_jumbotron') {
                            // Elfsight widgets are rendered once, near the footer, by <BottomSections>.
                            // Injecting them here too mounts the widget twice.
                            if (section.app_section_content.length > 0 && !section.app_section_content.includes('elfsight-app')) {
                                return (
                                    <React.Fragment key={'fr' + index} >
                                        <div key={index} dangerouslySetInnerHTML={{__html: section.app_section_content}}/>
                                    </React.Fragment>
                                )
                            }
                        }
                    })
                    :
                    <></>
            }

            {
                !isHomepage && destinations != null && destinations.count > 0
                    ?
                    <Suspense>
                        <DestinationsSection
                            key={'destinations'}
                            destinations={destinations}
                            isHomepage={isHomepage}
                        />
                    </Suspense>
                    :
                    <></>
            }

            {

                isExperiencesPage && experienceCategoriesContentDefault!=null && experienceCategoriesContentDefault.length > 0
                    ?
                    <>
                        {
                            experienceCategoriesContentDefault.map((item, index) => {

                                return (
                                    <React.Fragment key={'fragment' + index} >
                                        <Suspense>
                                            <ArticleCategoriesContainer
                                                key={index}
                                                app_data={app_data}
                                                app={app}
                                                builder={builder}
                                                type={'experiences'}
                                                content={item}
                                                isDesktop={isDesktop}
                                                articlesCategories={null}
                                                categoryIdInhrerited={item.id}
                                                includeJumbotron={false}
                                                includeTitle={!item.hide_title}
                                                itemClassName={'experience-design-box'}
                                            />
                                        </Suspense>
                                    </React.Fragment>
                                )
                            })
                        }
                    </>
                    :
                    <></>
            }



            {
                isVillaContentActive && propertyContent.location != null ?
                    <Suspense>
                        <GoogleMapSection
                            app={app}
                            container={'container-fluid'}
                            googleMapApiKey={app.googleMapsApiKey}
                            googleMapShow={app.viewMap && Checkers.valueToBoolean(app.builder.builder_singleproperty_show_map)}
                            property_lat={propertyContent.location.latitude}
                            property_lng={propertyContent.location.longitude}
                            map_pois={propertyContent.map_pois}
                            hidePin={Checkers.valueToBoolean(app.builder.builder_propertylist_map_hide_pin)}
                            descAreaDistances={Checkers.isValidObjString(propertyContent.details, 'desc_area_distances') && propertyContent.details.desc_area_distances}
                            propertyTitle={propertyContent.details?.property_title}
                            propertyImages={Checkers.isValidArray(propertyContent.album) ? propertyContent.album.map((image) => image.image_thumb || image.image) : []}
                            propertyAddress={propertyContent.location}
                        />
                    </Suspense>
                    :
                    <></>
            }

            {/*<Suspense>*/}
            {/*    <BottomSections*/}
            {/*        footerPaddingClass={!isDesktop ? 'search-xs-p-b-70' : ''}*/}
            {/*        key={'bottom_section'}*/}
            {/*        isDesktop={isDesktop}*/}
            {/*        contactSection={contact_section}*/}
            {/*        footerSection={footer_section}*/}
            {/*        app_data={app_data}*/}
            {/*        app={app}*/}
            {/*        head={head}*/}
            {/*        locations={locations}*/}
            {/*        footer={footer}*/}
            {/*        htmlSections={htmlSections}*/}
            {/*    />*/}
            {/*</Suspense>*/}
        </React.Fragment>
    )
}
